import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { StaticUrls } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Provincia } from '../models/provincia';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class ProvinciaService {

	private provinciaList: Provincia[];

	constructor(private http: AuthHttp) { }

	/**
	 * Il servizio non è profilato
	 * @returns {Observable<Provincia[]>}
	 * @memberof ProvinciaService
	 */
	get(): Observable<Provincia[]> {
		
		return this.http.get(StaticUrls._provincia)
			.map(this.handleResponse)
			.catch(this.handleError);
	}

	private handleResponse(response: Response) {
		this.provinciaList = response.json();
		return this.provinciaList;
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/provincia.service.ts